module.exports = __webpack_public_path__ + "static/media/snowboarding.fb5ded45.webp";